import script from "./PropertyProjectLogTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyProjectLogTab.vue?vue&type=script&setup=true&lang=js"

import "./PropertyProjectLogTab.vue?vue&type=style&index=0&id=00c6cdee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c6cdee"]])

export default __exports__